// skipcq: JS-W1028
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';

/**
 * Shared parchment dashboard card shell for Brewhouse widgets.
 */
function BrewhouseDashboardCard({ children, sx, ...rest }) {
  return (
    <Card
      sx={[
        {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...rest}
    >
      {children}
    </Card>
  );
}

BrewhouseDashboardCard.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

export default BrewhouseDashboardCard;
